"use strict";

CompanyActivitiesCtrl.$inject = [
  '$scope',
  '$stateParams',
  '$state',
  'CompanyFeedService',
  'CompanyService'];
function CompanyActivitiesCtrl(
  $scope,
  $stateParams,
  $state,
  CompanyFeedService,
  CompanyService) {
  $scope.feedLoading = false;

  $scope.$on('notification', function() {
    $scope.feedPage = 0;
    $scope.loadMoreFeed(true);
  });

  $scope.feedPage = 0;
  $scope.feed = [];
  $scope.loadMoreFeed = function(init) {
    if (!init) {
      $scope.feedPage += 1;
    }
    $scope.feedLoading = true;
    CompanyService.queryFeed({
      companyId: $stateParams.companyId,
      limit: 21,
      offset: 20 * $scope.feedPage
    }).$promise.then(function(resp){
      $scope.feedLoading = false;
      if (resp.length === 21) {
        $scope.feedHasMore = true;
        resp = resp.slice(0, 20);
      } else {
        $scope.feedHasMore = false;
      }
      resp = resp.map(function(v){
        return CompanyFeedService.feedTranslator(v, $scope.currentCompany.userType);
      });
      angular.forEach(resp, function(value, key){
        if(value && resp[key+1]){
          if(value.feed.performedBy === null){
            value.feed.avatar = {name: 'B O T'};
          }else{
            value.feed.avatar = value.feed.performedBy;
          }
          
          if((value.feed.action !== resp[key+1].feed.action && value.feed.performedBy !== resp[key+1].feed.performedBy) || value.feed.extra.objectType === 'CHECKLIST'){
            value.isShow = true;
          }else{
            var firstDatetime   = new Date(value.feed.performedAt);
            var lastDatetime   = new Date(resp[key+1].feed.performedAt);
            var timeDiff = Math.abs(firstDatetime.getTime() - lastDatetime.getTime())/(1000 * 60);
            if(timeDiff>1){
              var MinutesDiff = Math.abs(firstDatetime.getMinutes() - lastDatetime.getMinutes());
              if(MinutesDiff>1){
                value.isShow = true;
              }
            }
          }
        }
      });
      if (init) {
        $scope.feed = resp;
      } else {
        $scope.feed  = $scope.feed.concat(resp);
      }
    });
  };

  $scope.loadMoreFeed(true);
}

angular.module("dokiv")
  .controller("CompanyActivitiesCtrl", CompanyActivitiesCtrl);



//////////////////
// WEBPACK FOOTER
// ./scripts/company/comments/CompanyActivitiesCtrl.js
// module id = 322
// module chunks = 0